import {useState, useEffect} from 'react';
import axios from "axios";

const useModalItemFromHash = ({language, itemsArray, windowLocationHash, pagesArray, setCurrentModalItemIndex, setModalIsOpen, itemId}) => {
	const [modalItem, setModalItem] = useState([]);
	const lang = language === 'fr-FR' ? '/fr' : '';
	let baseUrl = window.origin;
	let reqUrl = `${baseUrl}${lang}/wp-json/bmo/v1/item`;

	useEffect(() => {
		const getModalItem = async (itemId) => {
			try {
				const { data } = await axios.get(reqUrl, {params: {id: itemId}});
				
				const formatData = (array) => {
					const arrayCopy = [...array];
					const newArray = [];
					const arrayItem = arrayCopy[0];
					const newGallery = arrayItem.gallery.filter(image => image.id !== arrayItem.image.id);
					arrayItem.gallery = newGallery;
					newArray.push(arrayItem);

					return newArray;
				}
				const formattedData = formatData(data);
				setModalItem(formattedData);
			} catch (error) {
				throw new Error('Api request failed', { cause: error });
			}
		}

		if (itemsArray.length > 0 && windowLocationHash) {
			let itemIdFromHash = Number(windowLocationHash);
			if (windowLocationHash.endsWith('/')) {
				itemIdFromHash = Number(windowLocationHash.slice(0, -1));
			}
			const isHistoryPage = pagesArray.length === 0;
			const isCollectionPage = pagesArray.length > 0;
			
			if (isHistoryPage) {
				const itemIndex = itemsArray.findIndex(item => item.id === itemIdFromHash);
				setCurrentModalItemIndex(itemIndex);
			}

			if (isCollectionPage && !itemId) {
				getModalItem(windowLocationHash);
				setCurrentModalItemIndex(0);
			}

			setModalIsOpen(true);
		}
        
		if (itemsArray.length > 0 && !windowLocationHash && !itemId) {
			setModalItem([]);
			window.history.pushState({}, '', window.location.pathname);
		}
	}, [windowLocationHash, itemId]);

	return [modalItem, setModalItem];
}

export default useModalItemFromHash;